export default __webpack_public_path__ + "static/media/obfuscation-1.56dc5533.md";